import React, { useState } from "react";
import { MacroHtmlEditorModal } from "./MacroHtmlEditorModal";

export interface MacroHtmlEditorFieldProps {
  name: string;
  field: any;
  value: string | undefined;
  onChange: (value: string) => void;
}

export function MacroHtmlEditorField(props: MacroHtmlEditorFieldProps) {
  const { value, onChange } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const displayValue = value || "";
  const previewText =
    displayValue.length > 100
      ? displayValue.substring(0, 100) + "..."
      : displayValue;

  return (
    <div className="flex flex-col gap-2">
      <div className="rounded border border-gray-300 bg-gray-50 p-2 text-xs font-mono text-gray-600 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 min-h-[60px] max-h-[120px] overflow-hidden">
        {previewText || <span className="italic text-gray-400">No content</span>}
      </div>
      <div className="flex items-center justify-between">
        <span className="text-[10px] text-gray-500">
          {displayValue.length} characters
        </span>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="rounded bg-blue-600 px-3 py-1 text-xs font-medium text-white hover:bg-blue-700"
        >
          Edit HTML
        </button>
      </div>

      <MacroHtmlEditorModal
        isOpen={isModalOpen}
        initialValue={displayValue}
        onClose={() => setIsModalOpen(false)}
        onSave={(newValue) => {
          onChange(newValue);
          setIsModalOpen(false);
        }}
      />
    </div>
  );
}
